<template>
    <div id="app">
<!--        <AgeValidation></AgeValidation>-->
        <Landing></Landing>
    </div>
</template>

<script>
    // import AgeValidation from './components/AgeValidation.vue'
    import Landing from './components/Landing.vue'

    export default {
        name: 'App',
        components: {
            // AgeValidation,
            Landing
        },
        mounted(){

        }
    }
</script>

<style>
    #app{
        overflow-x: hidden;
        background-color: #DB2127;
    }
</style>



